import LoggedOut from './logged-out.vue';

export default LoggedOut;
